<mat-form-field fxFlex="50" class="col-12" appearance="outline">
  <mat-label>{{ translateFieldName(fieldObject) }}</mat-label>
  <input type="datetime-local" matInput class="form-control" [ngModel]="formControlRef.value"  [formControl]="formControlRef"
         [placeholder]="translateFieldName(fieldObject)"  />
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName]">
    {{ fieldErrors[fieldObject.fieldName] }}
  </mat-error>
</mat-form-field>
